// src/useLocale.js
import { useContext } from 'react';
import { LocaleContext } from '../context/LocalContext'; // Adjust path if needed

const useLocale = () => {
  // Get the value (language, strings, changeLanguage) from the nearest LocaleProvider
  const context = useContext(LocaleContext);

  // Error checking: Ensure the hook is used within the Provider tree
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }

  // Return the context value, which now contains everything needed
  return context;
};

export default useLocale;